export enum PlayState {
  Paused,
  Play,
  Finished,
  Loading,
}
